export class CashGraphLines {
    public goal: number[] = [];
    public clientScenario: number[] = [];
}
